import { useTranslation } from "react-i18next"
import { Car } from "lucide-react"
import { useFeatureFlagEnabled } from "posthog-js/react"
import BaseSidebarButton from "./BaseSidebarButton"
import { TAB_TYPES } from "@/reducers/tabsSlice"

const MyCarsSidebarButton = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const enabled = Boolean(useFeatureFlagEnabled("my-cars"))
  if (!enabled) return null
  return (
    <BaseSidebarButton
      tabName={TAB_TYPES.MY_CARS}
      icon={Car}
      activeIcon={Car}
      tooltipText={t("app.sidebar.myCars")}
      className={className}
    />
  )
}

export default MyCarsSidebarButton
